import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Modal from "react-modal";
// import PtMembersTab from "./PtMembersTab";
import ButtonDice from "../../payouts-wtf/common/ButtonDice";
import PaginatedTable from "../../components-bootstrap/PaginatedTable";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ChangeTrainer from "../change-trainer/ChangeTrainer";
import FetchUserDetails from "../../payment-link-system/FetchUserDetails";
import { validatemap_form_email } from "../../../exports/Validations";
import { registerUser } from "../../../redux/reducers/postApiSlice";
import {
  fetchAllPTMembersData,
  fetchUserDetailsByMobileData,
} from "../../../redux/reducers/apiSlice";
import PaymentLinkForm from "../../payment-link-system/PaymentLinkForm";
import { selectAuth } from "../../auth/auth.selector";
import { BodyBuilder } from "../../../exports/Images";
import moment from "moment";
import ModalHeader from "../../ModalHeader";
import UserDetails from "../../incentive-system/user-details/UserDetails";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import CommonFilterStructure from "../../common-components/CommonFilterStructure";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";

const AllPtMembers = ({ queryParametersForAll, tableRef }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { userDetailsByMobile, ptMembersData } = useSelector(
    (state) => state.api
  );
  const isAdmin = decryptedText?.account_type === "admin";
  const initialUserFormData = {
    mobile: "",
    email: "",
    name: "",
    gender: "",
    user_id: "",
    dob: "",
  };
  const [userFormData, setUserFormData] = useState(initialUserFormData);
  const [isUserExist, setIsUserExist] = useState(false);
  const [canCallRegister, setCanCallRegister] = useState(false);
  const [isFetchUserDetaillsByMobile, setIsFetchUserDetaillsByMobile] =
    useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const initialPTMembers = {
    pageNo: 0,
    pagination: [],
    allPTMembers: [],
  };
  const [ptMemberDatas, setPTMemberDatas] = useState(initialPTMembers);
  const [selectedTrainer, setSelectedTrainer] = useState("");
  const iniPtMemTbFilters = {
    regularSubsStatus: "",
    ptSubsStatus: "",
    searchString: "",
  };
  const [ptMemTbFilters, setPtMemTbFilters] = useState(iniPtMemTbFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableQPs, setSendableQPs] = useState(
    !isAdmin
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : ""
  );
  const iniModValues = {
    isModalOpen: false,
    cardType: "",
    partialDetails: [],
    viewImage: "",
    rowData: null,
  };
  const [modValues, setModValues] = useState(iniModValues);

  const closeModal = () => {
    setModValues(iniModValues);
  };

  const onClickReset = () => {
    setPtMemTbFilters(iniPtMemTbFilters);
    setSendableQPs("");
    setPTMemberDatas((prevs) => ({ ...prevs, pageNo: 0 }));
  };

  function handleBack() {
    console.log("<=BACK");
    setUserFormData(initialUserFormData);
    setIsUserExist(false);
    setIsFetchUserDetaillsByMobile(false);
  }

  const handleRegisterUser = async (userData, TOKEN) => {
    setCanCallRegister(false);

    try {
      const actionResult = dispatch(registerUser({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        if (result.payload?.data) {
          setUserFormData({
            mobile: result.payload.data?.mobile,
            email: result.payload.data?.email,
            name: result.payload.data?.name,
            user_id: result.payload.data?.user_id,
          });
        }

        // setCreatePML(true);
        setModValues((prevs) => ({
          ...prevs,
          isModalOpen: true,
          cardType: "createPML",
        }));
        setIsUserExist(false);
      } else {
        const errorMessage = result?.error?.message || "Something Went Wrong!";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleRegisterUser ERROR => ", error);
    }
  };

  const onClickFetchUserDetails = () => {
    if (userFormData.mobile && userFormData.mobile?.length === 10) {
      dispatch(
        fetchUserDetailsByMobileData({
          userMobile: userFormData.mobile,
          token: decryptedText?.token,
        })
      );
      setIsFetchUserDetaillsByMobile(true);
    } else {
      toast.error("Please Enter Mobile Number! (Number Must Be 10 Digit)");
      setIsFetchUserDetaillsByMobile(false);
    }
  };

  const onClickRegisterUser = () => {
    if (
      !userFormData.mobile ||
      !userFormData.email ||
      !userFormData.name ||
      !userFormData.gender?.value
    ) {
      toast.error("Please Ensure All The Fields Are Filled!");
    } else if (!validatemap_form_email(userFormData.email)) {
      toast.error("Please Enter Correct Format of Email!");
    } else if (userFormData.mobile?.length !== 10) {
      toast.error("Please Enter Correct Format of Mobile Number!");
    } else {
      setCanCallRegister(true);
    }
  };

  const onClickSearch = () => {
    setIsSearch(true);
    setSearchFilterApplied(true);
    const searchQP = ptMemTbFilters.searchString
      ? `&search=${ptMemTbFilters.searchString}`
      : "";

    setSendableQPs((prevQP) => prevQP + searchQP);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  const formattedDate = (date) =>
    date ? moment(date).tz("Asia/Kolkata").format("DD-MM-YYYY") : "-";

  useEffect(() => {
    if (isFetchUserDetaillsByMobile && userDetailsByMobile?.status) {
      const { uid, name, email, gym_id, gym_name, dob, account_type } =
        userDetailsByMobile?.data?.[0];

      if (account_type !== "member") {
        toast.error("Enter Member Mobile Number!");
        return;
      } else if (!validatemap_form_email(email)) {
        toast.error("Member Email Is Not Valid! Please Update Email.");
        return;
      } else {
        setUserFormData({
          ...userFormData,
          name: name,
          email: email,
          gym_id: gym_id,
          gym_name: gym_name,
          user_id: uid,
          dob: dob,
        });
        // setCreatePML(true);
        setModValues((prevs) => ({
          ...prevs,
          isModalOpen: true,
          cardType: "createPML",
        }));
        setIsUserExist(false);
        setCanCallRegister(false);
      }
    } else if (userDetailsByMobile?.status === false) {
      setIsUserExist(true);
      toast.error(userDetailsByMobile?.message);
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (canCallRegister) {
      setUserFormData(initialUserFormData);
      const userData = {
        name: userFormData.name,
        mobile: userFormData.mobile,
        email: userFormData?.email,
        gender: userFormData.gender?.value,
        dob: userFormData.dob || "",

        is_web: 1,
        account_type: "member",
        otp: "otp",
        referral_code: "",
        n_token: "n_token",
      };

      handleRegisterUser(userData, decryptedText?.token);
    }
  }, [userFormData, canCallRegister]);

  useEffect(() => {
    if (
      modValues.cardType !== "paymentLinkModal" ||
      modValues.cardType !== "createPML"
    ) {
      setUserFormData(initialUserFormData);
    }
  }, [modValues.cardType]);

  useEffect(() => {
    const regSusbStatusQP = ptMemTbFilters.regularSubsStatus?.value
      ? `&regular_subscription_status=${ptMemTbFilters.regularSubsStatus.value}`
      : "";
    const ptSusbStatusQP = ptMemTbFilters.ptSubsStatus?.value
      ? `&subscription_status=${ptMemTbFilters.ptSubsStatus.value}`
      : "";

    const existingSearchQP = sendableQPs.includes("&search=")
      ? sendableQPs.match(/&search=([^&]*)/)[0]
      : "";

    setSendableQPs(
      `${queryParametersForAll}${regSusbStatusQP}${ptSusbStatusQP}${existingSearchQP}`
    );
  }, [queryParametersForAll, ptMemTbFilters]);

  useEffect(() => {
    dispatch(
      fetchAllPTMembersData({
        pageNo: ptMemberDatas.pageNo + 1,
        trainerId: selectedTrainer || "",
        searchString: "",
        queryParameters: sendableQPs || "",
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, ptMemberDatas.pageNo, selectedTrainer]);

  useEffect(() => {
    if (ptMembersData?.status && ptMembersData?.data?.length > 0) {
      setPTMemberDatas({
        ...ptMemberDatas,
        allPTMembers: ptMembersData.data,
        pagination: ptMembersData?.pagination,
      });
    } else {
      setPTMemberDatas(initialPTMembers);
    }
  }, [ptMembersData]);

  useEffect(() => {
    if (isSearch && ptMemTbFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setSendableQPs((prevs) => prevs.replace(/&search=[^&]*/, ""));
      setIsSearch(false);
    }
  }, [ptMemTbFilters.searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  function stringToColor(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const color = Math.abs(hash).toString(16).substring(0, 6);
    return `#${"0".repeat(6 - color.length)}${color}`;
  }

  const allPtMembers = [
    {
      dataField: "member_name",
      text: "Member",
      formatter: (cell, row, rowIndex) => (
        <div className="emeberDetailsRowContainer">
          {row?.member_profile ? (
            <img
              src={row?.member_profile || BodyBuilder}
              alt={row?.member_name || "N/A"}
              className="image"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModalOpen: true,
                  cardType: "imageModal",
                  viewImage: row?.member_profile || BodyBuilder,
                }));
              }}
            />
          ) : (
            <div
              className="nameInitials"
              style={{
                backgroundColor: stringToColor(row?.member_name || ""),
              }}
            >
              <span className="nameLetters">
                <span className="nameLetters">
                  {row?.member_name
                    ?.split(" ")
                    .map((namePart, index) =>
                      index === 0 ||
                      index === row?.member_name?.split(" ").length - 1
                        ? namePart.charAt(0).toUpperCase()
                        : null
                    )}
                </span>
              </span>
            </div>
          )}
          <p
            className="name hoverBlue info text-align-start bold"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModalOpen: true,
                cardType: "currentUserModal",
                rowData: row,
              }))
            }
            style={{
              fontWeight: 500,
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            {row?.member_name || "N/A"}
            <br />
            <small style={{ textTransform: "lowercase", fontWeight: "500" }}>
              {row?.member_mobile || ""}
              <br />
              {row?.member_email || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column minWidth150">
          <p className="name" style={{ fontWeight: "500" }}>
            {row?.gym_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer / Exp Level",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth150">
            {row?.trainer_name || "N/A"}
            <br />
            <small style={{ color: "gray" }}>
              {row?.experience_level || ""}
            </small>
          </p>
        </div>
      ),
    },
    {
      dataField: "is_partial",
      text: "Payment Type",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className={`info ${row?.is_partial === "true" ? "link" : ""}`}
            onClick={() =>
              row?.is_partial === "true"
                ? setModValues((prevs) => ({
                    ...prevs,
                    isModalOpen: true,
                    cardType: "partial_details",
                    partialDetails: row?.payment_details || [],
                  }))
                : null
            }
          >
            {row?.is_partial === "true" ? "Partial" : "Full"}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "price",
    //   text: "Amount/(Online,Cash)",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150 bold">
    //         {row?.is_partial === "true"
    //           ? `₹${convertThenFormat(
    //               row?.total_partial_price || 0
    //             )} / ${convertThenFormat(row?.price || 0)}`
    //           : `₹${convertThenFormat(row?.price || 0)}`}
    //         <br />
    //         <small style={{ fontWeight: "500" }}>
    //           (₹
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_online
    //               : row?.total_online || 0
    //           )}{" "}
    //           /{" "}
    //           {convertThenFormat(
    //             row?.is_partial === "true"
    //               ? row?.partial_total_cash
    //               : row?.total_cash || 0
    //           )}
    //           )
    //           <br />
    //           {row?.plan_name || ""}
    //         </small>
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "price",
      text: "Total Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">₹{convertThenFormat(row?.price || 0)}</p>
        </div>
      ),
    },
    {
      dataField: "total_partial_price",
      text: "Partial Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            {row?.is_partial === "true"
              ? `₹${convertThenFormat(row?.total_partial_price || 0)}`
              : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_online",
      text: "Online Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_online
                : row?.total_online || 0
            )}
          </p>
        </div>
      ),
    },
    {
      dataField: "total_cash",
      text: "Cash Amount",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info bold">
            ₹
            {convertThenFormat(
              row?.is_partial === "true"
                ? row?.partial_total_cash
                : row?.total_cash || 0
            )}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "session_status",
    //   text: "session status/duration/Last Session",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p
    //         className="info"
    //         style={{
    //           background: "#FFEDC0",
    //           color: "#171717",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.session_status || "NA"}
    //       </p>
    //       <small style={{ color: "gray", fontWeight: "500" }}>
    //         {row?.duration || 0} Days
    //         <br />
    //         {formattedDate(row?.last_session) || "-"}
    //       </small>
    //     </div>
    //   ),
    // },
    {
      dataField: "session_status",
      text: "session status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              background: "#FFEDC0",
              color: "#171717",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.session_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "duration",
      text: "session duration",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info">{row?.duration || 0} Days</p>
        </div>
      ),
    },
    {
      dataField: "last_session",
      text: "Last Session",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth100">
            {formattedDate(row?.last_session) || "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "date_added",
      text: "PT Date Added",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth100 bold">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "start_date",
    //   text: "Start/Expire Date",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth90 bold">
    //         {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
    //         <br />
    //         {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90 bold">
            {row?.start_date ? formatDateTimezon(row.start_date) : "-"}
          </p>
        </div>
      ),
    },
    {
      dataField: "expire_date",
      text: "Expire Date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info minWidth90 bold">
            {row?.expire_date ? formatDateTimezon(row.expire_date) : "-"}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "subscription_status",
    //   text: "PT / Regular Subscription status",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer minWidth150">
    //       <p
    //         className="info"
    //         style={{
    //           background:
    //             row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
    //           color:
    //             row?.subscription_status === "active" ? "#0A701B" : "#F13434",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.subscription_status || "NA"}
    //       </p>
    //       /{" "}
    //       <p
    //         className="info"
    //         style={{
    //           background:
    //             row?.regular_subscription_status === "active"
    //               ? "#B4E7B9"
    //               : "#F6EFEF",
    //           color:
    //             row?.regular_subscription_status === "active"
    //               ? "#0A701B"
    //               : "#F13434",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.regular_subscription_status || "NA"}
    //       </p>
    //     </div>
    //   ),
    // },
    {
      dataField: "subscription_status",
      text: "PT Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info minWidth100"
            style={{
              background:
                row?.subscription_status === "active" ? "#B4E7B9" : "#F6EFEF",
              color:
                row?.subscription_status === "active" ? "#0A701B" : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "regular_subscription_status",
      text: "Regular Subscription status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info minWidth100"
            style={{
              background:
                row?.regular_subscription_status === "active"
                  ? "#B4E7B9"
                  : "#F6EFEF",
              color:
                row?.regular_subscription_status === "active"
                  ? "#0A701B"
                  : "#F13434",
              borderRadius: "8px",
              padding: "5px 10px",
            }}
          >
            {row?.regular_subscription_status || "NA"}
          </p>
        </div>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer sendPaymentLink">
          <button
            type="button"
            className={`light-bordered-red-btn`}
            style={{ padding: "10px", width: "120px" }}
            onClick={() => {
              setModValues((prevs) => ({
                ...prevs,
                isModalOpen: true,
                cardType: "createPML",
              }));
              setUserFormData({
                mobile: row?.member_mobile || "",
                email: row?.member_email || "",
                name: row?.member_name || "",
                gender: row?.gender || "",
                user_id: row?.user_id || "",
                gym_name: row?.gym_name || "",
                gym_id: row?.gym_id || "",
              });
            }}
          >
            Send link
          </button>
        </div>
      ),
    },
  ];

  const pmInfoColumns = [
    {
      dataField: "payment_created",
      text: "Payment Created",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.payment_created
              ? formatDateTimezon(row.payment_created)
              : "-"}
          </span>
        );
      },
    },
    {
      dataField: "date",
      text: "Schedule Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.date ? convertStraight(row.date) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.amount || 0) || 0}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8"
            style={{
              background:
                row?.status === "pending"
                  ? "#FFEDC0"
                  : row?.status === "completed"
                  ? "#B4E7B9"
                  : "#F3DADA",
              color:
                row?.status === "pending"
                  ? "#171717"
                  : row?.status === "completed"
                  ? "#0A701B"
                  : "#D90000",
              borderRadius: "10px",
            }}
          >
            {row?.status || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`${
            modValues.cardType === "paymentLinkModal"
              ? "createNewCTOModalContainer fetchUserDetails"
              : modValues.cardType === "createPML"
              ? "createNewCTOModalContainer sendRenewalPaymentLinkModalContainer"
              : modValues.cardType === "imageModal"
              ? "createNewCTOModalContainer discussionModalBriefContainer"
              : modValues.cardType === "currentUserModal"
              ? "modal-body-k p-3 large bg-white rounded-5"
              : "createNewCTOModalContainer"
          }`}
          style={{
            width: modValues.cardType === "imageModal" ? "auto" : "",
            height: modValues.cardType === "imageModal" ? "auto" : "",
          }}
        >
          {modValues.cardType ===
          "changeTrainerModal" ? null : modValues.cardType ===
            "currentUserModal" ? (
            <ModalHeader title={"User Details"} onClick={closeModal} />
          ) : (
            <ModalHeadAndClose
              title={`${
                modValues.cardType === "createPML"
                  ? "Create Payment Link"
                  : modValues.cardType === "partial_details"
                  ? "Partial Details"
                  : ""
              }`}
              onClose={closeModal}
            />
          )}

          {modValues.cardType === "paymentLinkModal" ? (
            <FetchUserDetails
              isUserExist={isUserExist}
              userFormData={userFormData}
              setUserFormData={setUserFormData}
              onClickFetchUserDetails={onClickFetchUserDetails}
              onClickRegisterUser={onClickRegisterUser}
              handleBack={handleBack}
            />
          ) : modValues.cardType === "createPML" ? (
            <PaymentLinkForm
              paymentLinkData={userFormData}
              closeModal={() => {
                setUserFormData(initialUserFormData);
                closeModal();
              }}
              isComingPT={true}
            />
          ) : modValues.cardType === "changeTrainerModal" ? (
            <ChangeTrainer
              queryParametersForAll={queryParametersForAll}
              onCloseModal={closeModal}
            />
          ) : modValues.cardType === "currentUserModal" ? (
            <UserDetails
              row={modValues?.rowData}
              userInfoData={decryptedText}
            />
          ) : modValues.cardType === "imageModal" ? (
            <div className="discussionModalMessage">
              <img
                src={modValues.viewImage}
                alt="profile"
                style={{
                  width: "400px",
                  height: "400px",
                }}
              />
            </div>
          ) : modValues.cardType === "partial_details" ? (
            <div className="fullWidthFlexCenter separatedTable">
              <PayoutsTable
                dataValues={modValues.partialDetails}
                columnsValues={pmInfoColumns}
              />
            </div>
          ) : null}
        </div>
      </Modal>

      <div className="allPtMembersContainer mt30">
        <div className="headerSearchbar">
          <h2 className="header">All PT Members</h2>

          <ButtonDice
            buttonText1="Change Trainer"
            buttonText2="Send Payment link"
            // onClickButton1={() => setChangeTrainerModal(true)}
            // onClickButton2={() => setPaymentLinkModal(true)}
            onClickButton1={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModalOpen: true,
                cardType: "changeTrainerModal",
              }))
            }
            onClickButton2={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModalOpen: true,
                cardType: "paymentLinkModal",
              }))
            }
          />
        </div>

        <CommonFilterStructure
          from={"pt-flow-mem-table"}
          decryptedText={decryptedText}
          setFilters={setPtMemTbFilters}
          filters={ptMemTbFilters}
          searchFilterApplied={searchFilterApplied}
          onClickSearch={onClickSearch}
          handleKeyPress={handleKeyPress}
          onClickReset={onClickReset}
        />

        {/* <div
          className="ptMembersTabAndButtons"
          style={{ flexDirection: "column" }}
        >
          {selectedGymValue && (
            <PtMembersTab
              decryptedText={decryptedText}
              ptMemberDatas={ptMemberDatas}
              setPTMemberDatas={setPTMemberDatas}
              setSelectedTrainer={setSelectedTrainer}
              selectedGymValue={selectedGymValue}
              allPtMembers={allPtMembers}
            />
          )}
        </div> */}

        <div className="allPtMembersTableContainer" ref={tableRef}>
          <PaginatedTable
            columnsValues={allPtMembers}
            dataValues={ptMemberDatas.allPTMembers}
            paginationData={ptMemberDatas.pagination}
            isPage={ptMemberDatas.pageNo}
            setIsPage={(value) =>
              setPTMemberDatas((prevData) => ({
                ...prevData,
                pageNo: value,
              }))
            }
          />
        </div>
      </div>
    </>
  );
};

export default AllPtMembers;
